import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_PATIENT_INFO_DAILY_SESSION_FAILURE,
  GET_PATIENT_INFO_DAILY_SESSION_REQUEST,
  GET_PATIENT_INFO_DAILY_SESSION_SUCCESS,
  GET_PATIENT_INFO_DAILY_SESSION_LOADING,
} = dailySessionNotes;

function* getPatientInfo(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_INFO_DAILY_SESSION_LOADING });

    const response = yield call(dailySessionNotesService.getPatientInfo, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_INFO_DAILY_SESSION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_INFO_DAILY_SESSION_FAILURE, payload: error });
  }
}

function* getPatientInfoSaga() {
  yield takeEvery(GET_PATIENT_INFO_DAILY_SESSION_REQUEST, getPatientInfo);
}

export default getPatientInfoSaga;
